import client from "../client";
export const onSubjectRegistrationForAgeAssessment = async ({ formData }) => {
  return await client.post("/exams/subject", formData);
};

export const getAgeAssessmentTutorials = async () => {
  return await client.get("/tutorials");
};

export const getCollaborationsCases = async () => {
  return await client.get("/collaborations");
};

export const getCollaborationsCaseDetails = async ({ id }) => {
  return await client.get(`/collaborations/project/${id}`);
};

export const publishCase = async ({ id }) => {
  return await client.post(`/collaborations/project/${id}`);
};

export const getExamMethods = async () => {
  return await client.get("/exams");
};

export const getExamMethodInformation = async ({ slug }) => {
  return await client.get(`/exams/${slug}`);
};

export const submitPrimaryTeethExamResult = async ({ payload }) => {
  return await client.post("/exams/result/1", payload);
};
export const submitPermanentTeethExamResult = async ({ payload }) => {
  return await client.post("/exams/result/2", payload);
};
export const submitWisdomTeethExamResult = async ({ payload }) => {
  return await client.post("/exams/result/3", payload);
};
export const submitAdultsExamResult = async ({ payload }) => {
  return await client.post("/exams/result/4", payload);
};
export const addByColaborator = async ({ payload }) => {
  return await client.post("/collaborations", payload);
};
export const getFAQs = async ({ limit = 100 }) => {
  return await client.get(`/faqs?limit=${limit}`);
};
export const getProjectDetailsAsPdf = async ({ id }) => {
  return await client.get(`/collaborations/project/html/${id}`);
};
export const getAgeAssessmentDashoboardData = async () => {
  return await client.get("/dashboard");
};
export const addReviewerToProject = async ({ payload }) => {
  return await client.post("/reviewer", payload);
};
export const addConsultantToProject = async ({ payload }) => {
  return await client.post("/consultant", payload);
};
